function initializeVariantPicker(picker) {
  // Early exit conditions
  const url = new URL(window.location.href);
  if (window.Shopify.designMode || url.searchParams.has('variant')) return;

  // Get default variant data
  const defaultVariant = JSON.parse(picker.querySelector('script[data-default-variant]')?.textContent || '{}');
  if (!defaultVariant?.id || !defaultVariant?.options) return;

  // Cache DOM queries
  const carousel = document.querySelector('product-gallery')?.carousel;
  const form = document.forms[picker.getAttribute('form-id')];
  const variantScript = picker.querySelector('script[data-variant]');
  
  // Prevent scroll jump and carousel flicker
  const { scrollX, scrollY } = window;
  const scrollBehavior = document.documentElement.style.scrollBehavior;
  document.documentElement.style.scrollBehavior = 'auto';
  carousel?.setAttribute('data-skip-next-select', 'true');

  // Update variant data script
  variantScript.textContent = JSON.stringify(defaultVariant);

  // Create input map for faster lookups
  const inputMap = defaultVariant.options.reduce((map, _, index) => {
    const position = index + 1;
    map[position] = Array.from(picker.querySelectorAll(`input[data-option-position="${position}"]`));
    return map;
  }, {});

  // Select each option
  defaultVariant.options.forEach((optionValue, index) => {
    const position = index + 1;
    const input = inputMap[position]?.find(input => 
      input.nextElementSibling?.querySelector('span')?.textContent?.trim() === optionValue
    );
    
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // Update form variant ID
  if (form) {
    const idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      idInput.value = defaultVariant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Restore scroll position
  window.scrollTo(scrollX, scrollY);
  document.documentElement.style.scrollBehavior = scrollBehavior;
}

// Initialize only when needed
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('variant-picker').forEach(initializeVariantPicker);
  });
} else {
  document.querySelectorAll('variant-picker').forEach(initializeVariantPicker);
}